/* eslint-disable max-lines */
import { APP_ROLES, ACTION_TYPE_CAMPAIGN, MAX_TOP_CAMPAIGNS } from 'store/enums';
import store from 'store';
import {
  UI_RESET_COMMONS_FILTERS,
  UI_RESET_SECTION_FILTERS,
  UI_SET_RESET_SECTION,
  UI_SET_COMMON_FILTER,
  UI_IMAGES_BENCH_MASTER_DATA
} from 'store/actions/ui';
import { GET_MASTERDATA_MASIVE } from 'store/actions/automaticPublication';
import { RESET_SECTION_ODATA, CAMPAIGN_FRONT_DETAIL_BY_ID } from 'store/actions/campaign';
import { userSignedIn, userSignIn } from 'helpers/user';
import { lsGetResetSection } from 'helpers/store';
import { i18n } from '@/setup/i18n';

// Containers
const Full = () => import(/* webpackChunkName: "pages/main" */ '@/pages/main');

// Views
const KPI = () => import(/* webpackChunkName: "pages/views/dashboard/kpi" */ 'views/Dashboard/Kpi');
const OperationsListB2C = () =>
  import(
    /* webpackChunkName: "pages/views/operations/list-b2c" */
    'views/Operations/b2c/List'
  );
const OperationsListB2B = () =>
  import(
    /* webpackChunkName: "pages/views/operations/list-b2b" */
    'views/Operations/b2b/List'
  );
const Expiration = () =>
  import(
    /* webpackChunkName: "pages/views/operations/expiration" */
    'views/Operations/Expiration'
  );
const Showroom = () =>
  import(
    /* webpackChunkName: "pages/views/popupstore/showroom" */
    'views/Popupstore/Showroom'
  );
const NewCampaign = () =>
  import(
    /* webpackChunkName: "pages/views/garage/campaigns/new-campaign" */
    'views/Garage/Campaigns/NewCampaign'
  );
const EditMultipleCampaigns = () =>
  import(
    /* webpackChunkName: "pages/views/garage/campaigns/edit-multiple-campaigns" */
    'views/Garage/Campaigns/EditMultiple'
  );
const DetailAndEditCampaign = () =>
  import(
    /* webpackChunkName: "pages/views/garage/campaigns/edit-campaign" */
    'views/Garage/Campaigns/DetailAndEditCampaign'
  );
const ShowroomCampaignDetail = () =>
  import(
    /* webpackChunkName: "pages/views/popupstore/showroom/showroom-campaign-detail" */
    'views/Popupstore/Showroom/Detail'
  );
const ShowroomCampaignDetailSale = () =>
  import(
    /* webpackChunkName: "pages/views/popupstore/showroom/showroom-campaign-detail-sale" */
    'views/Popupstore/Showroom/Detail/Sale'
  );
const OperationDetailB2C = () =>
  import(
    /* webpackChunkName: "pages/views/operations/b2c/detail" */
    'views/Operations/b2c/Detail'
  );
const OperationDetailB2B = () =>
  import(
    /* webpackChunkName: "pages/views/operations/b2b/detail" */
    'views/Operations/b2b/Detail'
  );
const NewRequest = () =>
  import(
    /* webpackChunkName: "pages/views/popupstore/new-request" */
    'views/Popupstore/NewRequest'
  );
const NewRequestB2B = () =>
  import(
    /* webpackChunkName: "pages/views/popupstore/new-request-b2b" */
    'views/Popupstore/NewRequestB2B'
  );
const AddPartner = () =>
  import(
    /* webpackChunkName: "pages/views/garage/add-partner" */
    'views/Garage/AddPartner'
  );
const GarageCampaigns = () =>
  import(
    /* webpackChunkName: "pages/views/garage/campaigns" */
    'views/Garage/Campaigns'
  );
const Cms = () =>
  import(
    /* webpackChunkName: "pages/views/garage/cms" */
    'views/Garage/Cms'
  );
const SortCampaigns = () =>
  import(
    /* webpackChunkName: "pages/views/garage/campaigns/sort-campaigns" */ 'views/Garage/Campaigns/SortCampaigns'
  );
const ImagesBench = () =>
  import(
    /* webpackChunkName: "pages/views/images-bench" */
    'views/ImagesBench'
  );
const AutomaticPublication = () =>
  import(/* webpackChunkName: "pages/views/automaticPublication/" */ 'views/AutomaticPublication');
const PublishOffers = () =>
  import(
    /* webpackChunkName: "pages/views/automaticPublication/PublishOffers" */ 'views/AutomaticPublication/PublishOffers'
  );
const PublicationDetails = () =>
  import(
    /* webpackChunkName: "pages/views/automaticPublication/PublicationDetails" */ 'views/AutomaticPublication/PublicationDetails'
  );
const Page404 = () => import(/* webpackChunkName: "pages/views/errors/404" */ 'views/Errors/404');
const Page500 = () => import(/* webpackChunkName: "pages/views/errors/500" */ 'views/Errors/500');
const PageAccessDenied = () =>
  import(
    /* webpackChunkName: "pages/views/errors/access-denied" */
    'views/Errors/AccessDenied'
  );
const redirectToErrorPage = next =>
  next({
    name: '500'
  });
// Oidc
const OidcCallback = () =>
  import(
    /* webpackChunkName: "pages/oidc/callback" */
    '@/pages/main/Oidc/OidcCallback'
  );

export default [
  {
    path: '/oidc-callback',
    name: 'oidc-callback',
    component: OidcCallback,
    meta: {
      label: i18n.t('title.oidcCallback')
    }
  },
  {
    path: '/',
    name: 'full',
    component: Full,
    meta: {
      label: i18n.t('title.home')
    },
    beforeEnter(to, from, next) {
      const { loginHint, path } = to.query;
      if (loginHint) {
        const loginHintEnv = `${loginHint}|ALD`;
        userSignIn(loginHintEnv, { path }, 'autologin:true');
      } else {
        next();
      }
    },
    children: [
      {
        path: 'dashboard',
        redirect: '/dashboard/kpi',
        name: 'dashboard',
        component: {
          render(c) {
            return c('router-view');
          }
        },
        meta: {
          label: i18n.t('title.dashboard'),
          requiresAuth: true,
          roles: [
            APP_ROLES.ALD_ADMIN,
            APP_ROLES.ALD_USER,
            APP_ROLES.PARTNER_ADMIN,
            APP_ROLES.PARTNER_USER
          ]
        },
        children: [
          {
            path: 'kpi',
            name: 'kpi',
            component: KPI,
            meta: {
              label: i18n.t('title.kpi'),
              requiresAuth: true,
              roles: [
                APP_ROLES.ALD_ADMIN,
                APP_ROLES.ALD_USER,
                APP_ROLES.PARTNER_ADMIN,
                APP_ROLES.PARTNER_USER
              ]
            }
          }
        ]
      },
      {
        path: 'operations',
        redirect: '/operations/list-b2c',
        name: 'operations',
        component: {
          render(c) {
            return c('router-view');
          }
        },
        meta: {
          label: i18n.t('title.operations'),
          requiresAuth: true,
          roles: [
            APP_ROLES.ALD_ADMIN,
            APP_ROLES.ALD_USER,
            APP_ROLES.PARTNER_ADMIN,
            APP_ROLES.PARTNER_USER
          ]
        },
        children: [
          {
            path: 'list-b2c/:partnerId(\\d+)?',
            name: 'operations-list-b2c',
            component: OperationsListB2C,
            meta: {
              label: i18n.t('title.operationsListB2C'),
              requiresAuth: true,
              roles: [
                APP_ROLES.ALD_ADMIN,
                APP_ROLES.ALD_USER,
                APP_ROLES.PARTNER_ADMIN,
                APP_ROLES.PARTNER_USER
              ]
            },
            beforeEnter(to, from, next) {
              if (from.name === 'operation-detail-b2c') {
                next();
              } else {
                store
                  .dispatch(`ui/${UI_RESET_COMMONS_FILTERS}`)
                  .then(() => {
                    next();
                  })
                  .catch(() => {
                    redirectToErrorPage(next);
                  });
              }
            }
          },
          {
            path: 'list-b2b/:partnerId(\\d+)?',
            name: 'operations-list-b2b',
            component: OperationsListB2B,
            meta: {
              label: i18n.t('title.operationsListB2B'),
              requiresAuth: true,
              roles: [
                APP_ROLES.ALD_ADMIN,
                APP_ROLES.ALD_USER,
                APP_ROLES.PARTNER_ADMIN,
                APP_ROLES.PARTNER_USER
              ]
            },
            beforeEnter(to, from, next) {
              if (process.env.APP_SHOW_LIST_OPERATIONS_B2B === 'enabled') {
                if (from.name === 'operation-detail-b2b') {
                  next();
                } else {
                  store
                    .dispatch(`ui/${UI_RESET_COMMONS_FILTERS}`)
                    .then(() => {
                      next();
                    })
                    .catch(() => {
                      redirectToErrorPage(next);
                    });
                }
              } else {
                next({
                  name: 'operations-list-b2c'
                });
              }
            }
          },
          {
            path: 'expiration',
            name: 'operations-expiration',
            component: Expiration,
            meta: {
              label: i18n.t('title.expiration'),
              requiresAuth: true,
              roles: [
                APP_ROLES.ALD_ADMIN,
                APP_ROLES.ALD_USER,
                APP_ROLES.PARTNER_ADMIN,
                APP_ROLES.PARTNER_USER
              ]
            }
          },
          {
            path: 'b2c/:operationId(\\d+)',
            name: 'operation-detail-b2c',
            component: OperationDetailB2C,
            meta: {
              label: i18n.t('title.operationDetailB2C'),
              requiresAuth: true,
              roles: [
                APP_ROLES.ALD_ADMIN,
                APP_ROLES.ALD_USER,
                APP_ROLES.PARTNER_ADMIN,
                APP_ROLES.PARTNER_USER
              ]
            }
          },
          {
            path: 'b2b/:operationId(\\d+)',
            name: 'operation-detail-b2b',
            component: OperationDetailB2B,
            meta: {
              label: i18n.t('title.operationDetailB2B'),
              requiresAuth: true,
              roles: [
                APP_ROLES.ALD_ADMIN,
                APP_ROLES.ALD_USER,
                APP_ROLES.PARTNER_ADMIN,
                APP_ROLES.PARTNER_USER
              ]
            }
          }
        ]
      },
      {
        path: 'popupstore',
        redirect: '/popupstore/showroom',
        name: 'popup-store',
        component: {
          render(c) {
            return c('router-view');
          }
        },
        meta: {
          label: i18n.t('title.popupstore'),
          requiresAuth: true,
          roles: [
            APP_ROLES.ALD_ADMIN,
            APP_ROLES.ALD_USER,
            APP_ROLES.PARTNER_ADMIN,
            APP_ROLES.PARTNER_USER
          ]
        },
        children: [
          {
            path: 'showroom/:partnerId(\\d+)?',
            name: 'showroom',
            component: Showroom,
            meta: {
              label: i18n.t('title.showroom'),
              requiresAuth: true,
              roles: [
                APP_ROLES.ALD_ADMIN,
                APP_ROLES.ALD_USER,
                APP_ROLES.PARTNER_ADMIN,
                APP_ROLES.PARTNER_USER
              ]
            },
            beforeEnter(to, from, next) {
              if (from.name === 'showroom-campaign-detail') {
                next();
              } else {
                store
                  .dispatch(`ui/${UI_RESET_COMMONS_FILTERS}`)
                  .then(() => {
                    next();
                  })
                  .catch(() => {
                    redirectToErrorPage(next);
                  });
              }
            }
          },
          {
            path: 'showroom/new-request/:campaignId(\\d+)/:partnerId(\\d+)',
            name: 'new-request',
            component: NewRequest,
            meta: {
              label: i18n.t('title.newRequest'),
              requiresAuth: true,
              roles: [
                APP_ROLES.ALD_ADMIN,
                APP_ROLES.ALD_USER,
                APP_ROLES.PARTNER_ADMIN,
                APP_ROLES.PARTNER_USER
              ]
            },
            beforeEnter: async (to, from, next) => {
              try {
                await store.dispatch(`campaign/${CAMPAIGN_FRONT_DETAIL_BY_ID}`, {
                  campaignId: to.params.campaignId,
                  partnerId: to.params.partnerId
                });
                next();
              } catch (error) {
                next(false);
              }
            }
          },
          {
            path: 'showroom/new-request-b2b/:campaignId(\\d+)/:partnerId(\\d+)',
            name: 'new-request-b2b',
            component: NewRequestB2B,
            meta: {
              label: i18n.t('title.newRequestB2B'),
              requiresAuth: true,
              roles: [
                APP_ROLES.ALD_ADMIN,
                APP_ROLES.ALD_USER,
                APP_ROLES.PARTNER_ADMIN,
                APP_ROLES.PARTNER_USER
              ]
            }
          },
          {
            path: 'showroom/campaigns/:campaignId(\\d+)/:partnerId(\\d+)',
            name: 'showroom-campaign-detail',
            component: ShowroomCampaignDetail,
            meta: {
              label: i18n.t('title.campaignDetail'),
              requiresAuth: true,
              roles: [
                APP_ROLES.ALD_ADMIN,
                APP_ROLES.ALD_USER,
                APP_ROLES.PARTNER_ADMIN,
                APP_ROLES.PARTNER_USER
              ]
            }
          },
          {
            path: 'showroom/campaigns/:saleId(\\d+-\\d+)/:partnerId(\\d+)',
            name: 'showroom-campaign-detail-sale',
            component: ShowroomCampaignDetailSale,
            meta: {
              label: i18n.t('title.campaignDetail'),
              requiresAuth: true,
              roles: [
                APP_ROLES.ALD_ADMIN,
                APP_ROLES.ALD_USER,
                APP_ROLES.PARTNER_ADMIN,
                APP_ROLES.PARTNER_USER
              ]
            }
          }
        ]
      },
      {
        path: 'garage',
        redirect: '/garage/campaigns/:partnerId(\\d+)?',
        name: 'garage',
        component: {
          render(c) {
            return c('router-view');
          }
        },
        meta: {
          label: i18n.t('title.campaigns'),
          requiresAuth: true,
          roles: [APP_ROLES.ALD_ADMIN, APP_ROLES.ALD_USER]
        },
        children: [
          {
            path: 'partner/add',
            name: 'add-partner',
            component: AddPartner,
            meta: {
              label: i18n.t('title.addPartner'),
              requiresAuth: true,
              roles: [APP_ROLES.ALD_ADMIN, APP_ROLES.ALD_USER]
            }
          },
          {
            path: 'campaigns/:partnerId(\\d+)?',
            name: 'garage-campaigns',
            component: GarageCampaigns,
            meta: {
              label: i18n.t('title.garageCampaigns'),
              requiresAuth: true,
              roles: [APP_ROLES.ALD_ADMIN, APP_ROLES.ALD_USER]
            },
            beforeEnter(to, from, next) {
              if (['garage-campaign'].includes(from.name)) {
                // eslint-disable-next-line no-param-reassign
                to.meta.noRequest = true;
                next();
              } else if (lsGetResetSection('campaigns')) {
                store.commit(`ui/${UI_RESET_SECTION_FILTERS}`, { entity: 'campaigns' });
                store.commit(`ui/${UI_SET_COMMON_FILTER}`, {
                  filter: 'partner',
                  value: null
                });
                store.commit(`campaign/${RESET_SECTION_ODATA}`);
                store.commit(`ui/${UI_SET_RESET_SECTION}`, {
                  entity: 'campaigns',
                  value: false
                });
                next();
              } else if (to.name && !from.name) {
                // eslint-disable-next-line no-param-reassign
                delete to.meta.noRequest;
                next();
              } else {
                store.commit(`ui/${UI_RESET_SECTION_FILTERS}`, { entity: 'campaigns' });
                store.commit(`campaign/${RESET_SECTION_ODATA}`);
                // eslint-disable-next-line no-param-reassign
                delete to.meta.noRequest;
                next();
              }
            }
          },
          {
            path: 'campaigns/new-campaign/:campaignId(\\d+)?',
            name: 'garage-new-campaign',
            component: NewCampaign,
            meta: {
              label: i18n.t('title.newCampaign'),
              requiresAuth: true,
              roles: [APP_ROLES.ALD_ADMIN]
            }
          },
          {
            path: 'campaigns/edit/:actionType',
            name: 'edit-multiple-campaigns',
            component: EditMultipleCampaigns,
            meta: {
              label: i18n.t('title.editMultipleCampaigns'),
              requiresAuth: true,
              roles: [APP_ROLES.ALD_DEVELOPER]
            },
            beforeEnter(to, from, next) {
              const multipleCampaignsEdit = store.getters['campaign/dataCampaign'](
                'multipleCampaignsEdit'
              );
              if (multipleCampaignsEdit.length > 0) {
                next();
              } else {
                next({
                  name: 'garage'
                });
                next();
              }
            }
          },
          {
            path: 'campaigns/:campaignId(\\d+)/:actionType',
            name: 'garage-campaign',
            component: DetailAndEditCampaign,
            meta: {
              requiresAuth: true,
              roles: [
                APP_ROLES.ALD_ADMIN,
                APP_ROLES.ALD_USER,
                APP_ROLES.PARTNER_ADMIN,
                APP_ROLES.PARTNER_USER
              ]
            },
            beforeEnter(to, from, next) {
              let label = '';
              if (to.params.actionType === ACTION_TYPE_CAMPAIGN.DETAIL) {
                label = i18n.t('title.campaignDetail');
              }
              if (to.params.actionType === ACTION_TYPE_CAMPAIGN.CLONE) {
                label = i18n.t('title.cloneCampaign');
              }
              if (to.params.actionType === ACTION_TYPE_CAMPAIGN.EDIT) {
                label = i18n.t('title.editCampaign');
              }
              if (to.params.actionType === ACTION_TYPE_CAMPAIGN.ADVANCED_EDIT) {
                label = i18n.t('title.advancedEditCampaign');
              }
              // eslint-disable-next-line no-param-reassign
              to.meta.label = label;
              next();
            }
          },
          {
            path: 'cms/edit',
            name: 'cms',
            component: Cms,
            meta: {
              label: i18n.t('title.cms'),
              requiresAuth: true,
              roles: [APP_ROLES.ALD_ADMIN, APP_ROLES.ALD_USER]
            }
          },
          {
            path: 'campaigns/sort-campaigns',
            name: 'sort-campaigns',
            component: SortCampaigns,
            meta: {
              label: i18n.t('title.sortCampaigns'),
              requiresAuth: true,
              roles: [APP_ROLES.ALD_ADMIN, APP_ROLES.ALD_USER]
            },
            beforeEnter(to, from, next) {
              if (['garage-campaign'].includes(from.name)) {
                // eslint-disable-next-line no-param-reassign
                to.meta.noRequest = true;
                next();
              } else if (lsGetResetSection('campaigns')) {
                store.commit(`ui/${UI_RESET_SECTION_FILTERS}`, {
                  entity: 'campaigns',
                  perPage: to.params?.partner?.maxTopCampaigns || MAX_TOP_CAMPAIGNS,
                  sortDesc: false,
                  totalRows: to.params?.partner?.maxTopCampaigns || MAX_TOP_CAMPAIGNS
                });
                store.commit(`ui/${UI_SET_COMMON_FILTER}`, {
                  filter: 'partner',
                  value: null
                });
                store.commit(`campaign/${RESET_SECTION_ODATA}`);
                store.commit(`ui/${UI_SET_RESET_SECTION}`, {
                  entity: 'campaigns',
                  value: false
                });
                next();
              } else if (to.name && !from.name) {
                // eslint-disable-next-line no-param-reassign
                delete to.meta.noRequest;
                next();
              } else {
                store.commit(`ui/${UI_RESET_SECTION_FILTERS}`, {
                  entity: 'campaigns',
                  perPage: to.params?.partner?.maxTopCampaigns || MAX_TOP_CAMPAIGNS,
                  sortDesc: false,
                  totalRows: to.params?.partner?.maxTopCampaigns || MAX_TOP_CAMPAIGNS
                });
                store.commit(`campaign/${RESET_SECTION_ODATA}`);
                // eslint-disable-next-line no-param-reassign
                delete to.meta.noRequest;
                next();
              }
            }
          }
        ]
      },
      {
        path: 'automatic-publication',
        component: {
          render(c) {
            return c('router-view');
          }
        },
        meta: {
          label: i18n.t('title.automaticPublication'),
          requiresAuth: true,
          roles: [APP_ROLES.ALD_ADMIN, APP_ROLES.ALD_USER]
        },
        beforeEnter(to, from, next) {
          store
            .dispatch(`automaticPublication/${GET_MASTERDATA_MASIVE}`, {
              campaignId: to.params.campaignId,
              partnerId: to.params.partnerId
            })
            .then(() => {
              next();
            })
            .catch(() => {
              redirectToErrorPage(next);
            });
        },
        children: [
          {
            path: '',
            name: 'automaticPublication',
            component: AutomaticPublication,

            meta: {
              label: i18n.t('title.automaticPublication'),
              requiresAuth: true,
              roles: [APP_ROLES.ALD_ADMIN, APP_ROLES.ALD_USER]
            },
            beforeEnter(to, from, next) {
              store
                .dispatch(`automaticPublication/${GET_MASTERDATA_MASIVE}`, {
                  campaignId: to.params.campaignId,
                  partnerId: to.params.partnerId
                })
                .then(() => {
                  next();
                })
                .catch(() => {
                  redirectToErrorPage(next);
                });
            }
          },
          {
            path: ':id',
            name: 'publicationDetails',
            component: PublicationDetails,
            meta: {
              label: i18n.t('title.automaticPublicationDetails'),
              requiresAuth: true,
              roles: [APP_ROLES.ALD_ADMIN, APP_ROLES.ALD_USER]
            },
            beforeEnter(to, from, next) {
              if (from.name) {
                store
                  .dispatch(`automaticPublication/${GET_MASTERDATA_MASIVE}`, {
                    campaignId: to.params.campaignId,
                    partnerId: to.params.partnerId
                  })
                  .then(() => {
                    next();
                  })
                  .catch(() => {
                    redirectToErrorPage(next);
                  });
              } else {
                next({ name: 'automaticPublication' });
              }
            }
          }
        ]
      },
      {
        path: 'automatic-publication/publish-offers',
        name: 'publishOffers',
        component: PublishOffers,
        meta: {
          label: i18n.t('title.publishOffers'),
          requiresAuth: true,
          roles: [APP_ROLES.ALD_ADMIN, APP_ROLES.ALD_USER]
        },
        beforeEnter(to, from, next) {
          store
            .dispatch(`automaticPublication/${GET_MASTERDATA_MASIVE}`, {
              campaignId: to.params.campaignId,
              partnerId: to.params.partnerId
            })
            .then(() => {
              next();
            })
            .catch(() => {
              redirectToErrorPage(next);
            });
        }
      },
      {
        path: 'images-bench',
        name: 'images-bench',
        component: ImagesBench,
        meta: {
          label: i18n.t('title.imagesBench'),
          requiresAuth: true,
          roles: [APP_ROLES.ALD_ADMIN, APP_ROLES.ALD_USER]
        },
        beforeEnter(to, from, next) {
          store
            .dispatch(`ui/${UI_IMAGES_BENCH_MASTER_DATA}`)
            .then(() => {
              next();
            })
            .catch(() => {
              redirectToErrorPage(next);
            });
        }
      },
      {
        path: 'access-denied',
        name: 'access-denied',
        component: PageAccessDenied,
        meta: {
          label: i18n.t('title.accessDenied')
        }
      },
      {
        path: 'error',
        name: '500',
        component: Page500,
        meta: {
          label: i18n.t('title.error500')
        }
      },
      {
        path: '*',
        name: '404',
        component: Page404,
        meta: {
          label: i18n.t('title.error404')
        },
        async beforeEnter(to, from, next) {
          if (to.path === '/') {
            const signedIn = await userSignedIn();
            next({
              name: signedIn ? 'operations' : 'full',
              query: to.query
            });
          } else {
            next();
          }
        }
      }
    ]
  }
];
